<template>
  <section class="block-promotions promotions">
    <div class="container">
      <div class="promotions__head">
        <h2 class="promotions__title title">Акции</h2>
        <div class="swiper-pagination"></div>
        <div class="promotions__controls" v-if="device_platform !== 'mobile'">
          <div class="arrow arrow-prev"></div>
          <div class="arrow arrow-next"></div>
        </div>
      </div>
      <div class="swiper-container promotions-swiper">
        <div class="swiper-wrapper promotions__swiper-wrapper">
          <div
            class="swiper-slide"
            :class="'_' + slide.id"
            v-for="(slide, index) in slides"
            :key="index"
            @click="
              getCall({
                type: 'sale',
                form: 'promotions',
                title: `${slide.title}`,
              })
            "
          >
            <div class="promotions__content">
              <h3 class="promotions__name" v-html="slide.title"></h3>
              <p class="promotions__text">{{ slide.text }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import Mixin from "../common/mixin";
import Swiper from "swiper";

export default {
  name: "block-promotions",
  mixins: [Mixin],
  data() {
    return {
      swiper: null,
      slides: [
        {
          id: 1,
          title: "Скидки",
          text: "Только в этом месяце снижаем цены для студентов! Успейте воспользоваться предложением!",
        },
        // {
        //   id: 2,
        //   title: "Налоговый вычет",
        //   text: "Наш клуб входит в список Минспорта. Купите абонемент и верните 13% от стоимости",
        // },
        {
          id: 3,
          title: "Скидки на персональные тренировки",
          text: "Тренируйтесь под руководством профессионального тренера по сниженным ценам!",
        },
        // {
        //   id: 4,
        //   title: "Ежемесячная оплата",
        //   text: "Займитесь фитнесом сейчас – платите потом!",
        // },
        // {
        //   id: 5,
        //   title: "Приведи друга с собой",
        //   text: "Заниматься спортом вместе выгоднее!",
        // },
        {
          id: 6,
          title: "Корпоративным клиентам",
          text: "Специальные условия для групп от 10 человек",
        },
        // {
        //   id: 7,
        //   title: "Семейные абонементы",
        //   text: "Занимайтесь всей семьёй",
        // },
      ],
    };
  },
  mounted() {
    this.initSwiper();
  },
  methods: {
    initSwiper() {
      if (this.swiper) return;
      this.swiper = new Swiper(`.promotions-swiper`, {
        slidesPerView: "auto",
        spaceBetween: 16,
        loop: false,
        simulateTouch: true,
        navigation: {
          nextEl: `.promotions .arrow-next`,
          prevEl: `.promotions .arrow-prev`,
        },
        pagination: {
          el: ".promotions .swiper-pagination",
          type: "progressbar",
        },
        breakpoints: {
          800: {
            spaceBetween: 12,
          },
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../styles/constants.scss";

.promotions {
  padding-top: 78px;

  &__head {
    position: relative;
    display: flex;
    align-items: flex-end;
    margin-bottom: 20px;
  }

  &__swiper-wrapper{
    display: flex;
    justify-content: space-between;
  }

  .swiper-slide {
    position: relative;
    max-width: 400px;
    height: 408px;
    background-color: #8e8e8e;
    color: #fff;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    padding: 24px;
    cursor: pointer;
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;

    @each $img in 1, 2, 3, 4, 5, 6, 7 {
      &._#{$img} {
        background-image: url("../images/promotions/#{$img}.jpg");
      }
    }

    &:hover {
      .promotions__content {
        transform: translateY(-100px);
      }
    }
  }

  .swiper-pagination {
    position: unset;
    flex: 1;
    height: 2px;
    margin: 0 13px 9px;
  }

  &__controls {
    display: flex;
    align-items: center;
    margin-bottom: 9px;
  }

  &__content {
    height: 160px;
    position: relative;
    z-index: 2;
    transition: transform 0.3s cubic-bezier(0.165, 0.84, 0.44, 1);
  }

  &__name {
    font-size: 24px;
    font-family: "Bebas Neue", sans-serif;
    margin-bottom: 12px;
    letter-spacing: 0.05em;
  }

  &__text {
    font-size: 18px;
    line-height: 130%;
  }
}

@media (max-width: 800px) {
  .promotions {
    padding-top: 56px;
    .swiper-slide {
      max-width: 213px;
      height: 272px;
      padding: 12px;
    }

    &__name {
      font-size: 18px;
      margin-bottom: 4px;
    }
    &__text {
      font-size: 14px;
    }
    &__content {
      height: 135px;
    }
  }
}

@media (max-width: 640px) {
  .promotions {
    padding-top: 40px;
    .swiper-slide {
      max-width: 195px;
      height: 248px;
    }
  }
}
</style>
